import { useMemo } from 'react';
import Grid from './Grid';
import List from './List';
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import styles from './QrCard.module.css';

export default function QrCard(props) {
    // ----- STATE INITIALIZATION -----
    const { QR, layout, childQRs } = props;

    const total = useMemo(() => {
        const scanCount = QR.data?.scanCount_cache || 0;
        if (childQRs.length > 0) {
            return [scanCount, ...childQRs.map(child => child.data?.scanCount_cache || 0)].reduce((sum, cur) => {
                sum += cur;
                return sum;
            }, 0);
        } else return scanCount;
    },[QR.data?.scanCount_cache, childQRs]);

    return (
        <AnimatePresence mode='wait'>
            {layout === 'list' ? (
                <motion.div
                    className={styles.listContainer}
                    key='list'
                    transition={transition}
                    variants={variants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <List
                        QR={QR}
                        total={total}
                        childQRs={childQRs}
                    />
                </motion.div>
            ) : (
                <motion.div
                    className={styles.gridContainer}
                    key='grid'
                    transition={transition}
                    variants={variants}
                    initial='initial'
                    animate='animate'
                    exit='initial'
                >
                    <Grid
                        QR={QR}
                        total={total}
                        childQRs={childQRs}
                    />
                </motion.div>
            )}
        </AnimatePresence>
    )
};